// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__1pFWk","btn":"index_btn__B7zBe","img":"index_img__2R1G9"};